// https://gist.github.com/eddiemoore/7131781

export const validateNRIC = (str, isNric = true) => {
  if (!str || str.length !== 9) return false

  str = str.toUpperCase()

  var i,
    icArray = []
  for (i = 0; i < 9; i++) {
    icArray[parseInt(i)] = str.charAt(i)
  }

  if (isNric) {
    if (icArray[0] !== 'S' && icArray[0] !== 'T') {
      return false
    }
  } else if (icArray[0] !== 'F' && icArray[0] !== 'G' && icArray[0] !== 'M') {
    return false
  }

  icArray[1] = parseInt(icArray[1], 10) * 2
  icArray[2] = parseInt(icArray[2], 10) * 7
  icArray[3] = parseInt(icArray[3], 10) * 6
  icArray[4] = parseInt(icArray[4], 10) * 5
  icArray[5] = parseInt(icArray[5], 10) * 4
  icArray[6] = parseInt(icArray[6], 10) * 3
  icArray[7] = parseInt(icArray[7], 10) * 2

  var weight = 0
  for (i = 1; i < 8; i++) {
    weight += icArray[parseInt(i)]
  }

  var offset =
    icArray[0] === 'T' || icArray[0] === 'G' ? 4 : icArray[0] === 'M' ? 3 : 0
  var temp = (offset + weight) % 11
  if (icArray[0] === 'M') temp = 10 - temp

  var st = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A']
  var fg = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K']
  var m = ['K', 'L', 'J', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X']

  var theAlpha
  if (icArray[0] === 'S' || icArray[0] === 'T') {
    theAlpha = st[parseInt(temp)]
  } else if (icArray[0] === 'F' || icArray[0] === 'G') {
    theAlpha = fg[parseInt(temp)]
  } else if (icArray[0] === 'M') {
    theAlpha = m[parseInt(temp)]
  }

  return icArray[8] === theAlpha
}
